import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: [],
})
export class App {
  constructor() {
    const authService = inject(AuthService);
    if (authService.isAuthenticated()) {
      authService.refreshUser().subscribe();
    }
  }
}
